import { InjectionToken } from '@angular/core';
import { ViewAction } from '@antony/ng-ui';

export const PROFILE_VIEW_ACTIONS = new InjectionToken<ViewAction>('app.navigation.profile.view_actions');
